import { Label, Error } from 'components/lib';
import Style from './input.tailwind.js';

interface CardInputProps {
  errorMessage?: string;
  className?: string;
  valid?: boolean;
  label?: string;
  required?: boolean;
  name?: string;
}

export function CardInput(props: CardInputProps) {
  const error = props.errorMessage || 'Please provide valid credit card details';

  return (
    <div className={Style.input}>
      <Label text={props.label} required={props.required} for={props.name} />

      {props.valid === false && <Error message={error} />}
    </div>
  );
}
